<app-preloader></app-preloader>

<app-nav-bar></app-nav-bar>

  <router-outlet></router-outlet>

<app-footer></app-footer>
